// extracted by mini-css-extract-plugin
export var width100 = "z_w d_w";
export var design3Pos = "z_vd d_0";